<template>
  <div class="PageSubscribeSuccess">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="5">
          <v-card class="pa-6 text-center">
            <v-icon size="72" color="success" class="mb-4">mdi-check-circle</v-icon>
            <v-card-title class="justify-center text-h5 mb-2">Assinatura confirmada!</v-card-title>
            <v-card-text class="body-1 grey--text">
              Seu Plano Pro está ativo. Agora você pode adicionar pacientes ilimitados
              e acessar todos os recursos avançados de análise.
            </v-card-text>
            <v-card-actions class="justify-center mt-2">
              <v-btn color="primary" @click="$router.push('/patients')">
                Ir para Meus Pacientes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { SubscriptionService } from '../../lib/spasms-control'
import { getToken } from '../../utils'
import store from '../../store'

export default {
  name: 'PageSubscribeSuccess',
  async mounted () {
    try {
      const service = new SubscriptionService(getToken())
      const data = await service.getStatus()
      store.setSubscriptionAction(data)
    } catch (err) {
      console.error(err)
    }
  }
}
</script>
